import isomorphicRoute from '@client/helperComponents/isomorphicRoute';
import Loader from '@client/components/loader/Loader';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import { routesCreateIF } from '@client/pages/createIFPage/routesCreateIF';
import { routesDonation } from '@client/pages/donatePage/routesDonation';
import { routesProfile } from '@client/pages/profilePage/routesProfile';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

export default [
  {
    path: '/',
    exact: true,
    componentPath: 'pages/homePage/HomePage',
    Component: isomorphicRoute(
      () => import('pages/homePage/HomePage'),
      options
    ),
  },
  routesCreateIF,
  {
    path: '/insamling/:fundraiserSlug',
    exact: true,
    componentPath: 'pages/individualFundraiserPage/IndividualFundraiserPage',
    Component: isomorphicRoute(
      () => import('pages/individualFundraiserPage/IndividualFundraiserPage'),
      options
    ),
  },
  routesDonation,
  routesProfile,
  {
    path: '/login',
    exact: true,
    componentPath: 'pages/loginPage/LoginPage',
    Component: isomorphicRoute(
      () => import('pages/loginPage/LoginPage'),
      options
    ),
  },
  {
    path: '/sign-up',
    exact: true,
    componentPath: 'pages/signUpPage/SignUpPage',
    Component: isomorphicRoute(
      () => import('pages/signUpPage/SignUpPage'),
      options
    ),
  },
  {
    path: '/hjalp',
    exact: true,
    componentPath: 'pages/helpPage/HelpPage',
    Component: isomorphicRoute(
      () => import('pages/helpPage/HelpPage'),
      options
    ),
  },
  {
    path: '/om-cookies',
    exact: true,
    componentPath: 'pages/aboutCookiesPage/AboutCookiesPage',
    Component: isomorphicRoute(
      () => import('pages/aboutCookiesPage/AboutCookiesPage'),
      options
    ),
  },
  {
    path: '/event/:eventName',
    componentPath: 'pages/eventPage/EventPage',
    Component: isomorphicRoute(
      () => import('pages/eventPage/EventPage'),
      options
    ),
  },
  {
    path: '/minnesfonder',
    exact: true,
    componentPath: 'pages/memorialFundraisersPage/MemorialFundraisersPage',
    Component: isomorphicRoute(
      () => import('pages/memorialFundraisersPage/MemorialFundraisersPage'),
      options
    ),
  },
  {
    path: '/minnesfonder/:fundraiserSlug',
    componentPath: 'pages/individualFundraiserPage/IndividualFundraiserPage',
    Component: isomorphicRoute(
      () => import('pages/individualFundraiserPage/IndividualFundraiserPage'),
      options
    ),
  },
  {
    path: '/from-invite',
    componentPath: 'pages/loginToClaimPage/LoginToClaimPage',
    Component: isomorphicRoute(
      () => import('pages/loginToClaimPage/LoginToClaimPage'),
      options
    ),
  },
  {
    path: '/insamlingar',
    componentPath: 'pages/allFundRaisersPage/AllFundRaisersPage',
    Component: isomorphicRoute(
      () => import('pages/allFundRaisersPage/AllFundRaisersPage'),
      options
    ),
  },
  {
    path: '/assets/:fundraiserSlug',
    exact: true,
    componentPath: 'pages/assetsPage/AssetsPage',
    Component: isomorphicRoute(
      () => import('pages/assetsPage/AssetsPage'),
      options
    ),
  },
  {
    path: '*',
    componentPath: 'pages/notFoundPage/NotFoundPage',
    Component: isomorphicRoute(
      () => import('pages/notFoundPage/NotFoundPage'),
      options
    ),
    status: 404,
  },
];
